<template>
    <div class="waba-supsis-account-violation">
        <div class="title">{{ $t("auto.whatsappBusinessApiV2AccountViolationDetected") }}</div>
        <div class="meta">
            <div><b>{{ $t("auto.event") }}</b>: {{ $_.get(activity, "payload.event") }}</div>
            <div><b>{{ $t("auto.channelId") }}</b>: {{ $_.get(activity, "payload.channelId") }}</div>
            <div><b>{{ $t("auto.violationType") }}</b>: {{ $_.get(activity, "payload.violation_info.violation_type") }}</div>
            <div><b>{{ $t("auto.accountId") }}</b>: {{ $_.get(activity, "payload.entry[0].id") }}</div>
        </div>
        <details class="raw">
            <summary>{{ $t("auto.rawPayload") }}</summary>
            <pre>{{ prettyPayload }}</pre>
        </details>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "WabaSupsisAccountViolation",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        prettyPayload() {
            try {
                return JSON.stringify(this.$_.get(this.activity, "payload", {}), null, 2);
            } catch (e) {
                return String(this.$_.get(this.activity, "payload", ""));
            }
        },
    },
});
</script>

<style scoped lang="scss">
.waba-supsis-account-violation {
    .title {
        font-weight: 600;
        margin-bottom: 6px;
    }
    .meta {
        display: flex;
        flex-direction: column;
        gap: 2px;
        margin-bottom: 8px;
    }
    .raw {
        pre {
            max-height: 240px;
            overflow: auto;
            padding: 10px;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
        }
        summary {
            cursor: pointer;
            user-select: none;
            margin-bottom: 6px;
        }
    }
}
</style>
